import React from 'react';
import {ButtonBase} from '@material-ui/core';
import QCTooltip from '@pluto/qc-tooltip';

import {PlayIcon, PauseIcon} from 'VideoAudioQC/icons';

export interface PlayPauseButtonProps {
    paused: boolean;
    onPause: () => void;
    onPlay: () => void;
}

export default function PlayPauseButton(props: PlayPauseButtonProps) {
    const {paused, onPause, onPlay} = props;

    if (paused) {
        return (
            <QCTooltip title="Toggle Playback (Space)" arrow>
                <ButtonBase
                    onClick={onPlay}
                    aria-label="Play"
                    aria-keyshortcuts="Space"
                    className="play-pause"
                >
                    <PlayIcon />
                </ButtonBase>
            </QCTooltip>
        );
    }

    return (
        <QCTooltip title="Toggle Playback (Space)" arrow>
            <ButtonBase
                onClick={onPause}
                aria-label="Pause"
                aria-keyshortcuts="Space"
                className="play-pause"
            >
                <PauseIcon />
            </ButtonBase>
        </QCTooltip>
    );
}
